import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import { ProjectImage } from "entities/projects/ui/project-image/ProjectImage"

import { useProjectCardContext } from "../ProjectCardContext"

export const ProjectCardImage = React.memo(({ className }: WithClassName) => {
  const { isLoading, model } = useProjectCardContext()
  return (
    <ProjectImage
      isLoading={isLoading}
      color={model?.core.data.project?.data?.ui?.color}
      className={classNames("project-card__image", className)}
    />
  )
})

ProjectCardImage.displayName = "ProjectCardImage"
